import { NOT_SELECTED_ERROR } from '../../constants'

const validate = ({ selectedStore }) => {
  const errors = {}

  if (!selectedStore) {
    errors.selectedStore = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  }

  return errors
}

export default validate
